export function onVisible(
  element: HTMLElement,
  callback: () => void,
  options: IntersectionObserverInit = { threshold: 0.1 }
) {
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      callback()
      observer.disconnect()
    }
  }, options)

  observer.observe(element)
}